import { render } from "./BookingModal.vue?vue&type=template&id=fcb64e9a&scoped=true&ts=true"
import script from "./BookingModal.vue?vue&type=script&lang=ts"
export * from "./BookingModal.vue?vue&type=script&lang=ts"

import "./BookingModal.vue?vue&type=style&index=0&id=fcb64e9a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb64e9a"]])

export default __exports__